import { Channel, Client, Member, Message } from "revolt.js";

type Role = {
    id: string;
} & Member["orderedRoles"][number][1];

export function getRolesInChannel(channel: Channel): Role[] {
    const roles: Map<string, Role> = new Map();

    const server_id = channel.server_id;
    if (!server_id) return [];

    channel.client.members.forEach((member) => {
        const hasPermission = member.hasPermission(channel, "ViewChannel");
        if (hasPermission && member.server?._id === server_id) {
            member.orderedRoles.forEach(([id, data]) => {
                roles.set(id, {
                    id,
                    ...data,
                });
            });
        }
    });

    return [...roles.values()];
}

export function getRolesInClient(client: Client): Role[] {
    const roles: Map<string, Role> = new Map();

    client.members.forEach((member) => {
        member.orderedRoles.forEach(([id, data]) => {
            roles.set(id, {
                id,
                ...data,
            });
        });
    });

    return [...roles.values()];
}

export function isMentionedByRole(message: Message): boolean {
    if (!message.channel?.server_id) {
        return false;
    }
    const client = message.client;

    const member = client.members.getKey({
        server: message.channel?.server_id,
        user: client.user!._id,
    });

    const userRoles = member?.roles;
    return (
        new Set(message.role_mentions).intersection(new Set(userRoles)).size !==
        0
    );
}
